<template>
  <validation-observer
      ref="form"
      #default="{ invalid }"
      tag="form"
      class="repeater__form"
      style="overflow: visible"
  >
    <b-modal
        v-model="show"
        content-class="package-modal rounded-8"
        dialog-class="wameed-modal-md"
        no-fade
    >
      <template slot="modal-header-close">
        <close-icon/>
      </template>
      <template slot="modal-title">
        <div class="d-block text-center">
          <h3 class="text-reg-18">
            {{ modalData != null ? $t('serviceDetails.update_btn') : $t('serviceDetails.new_btn') }}
          </h3>
        </div>
      </template>


      <b-row>
        <b-col md="6" v-if="modalData == null">
          <b-form-group
        label="نوع الخدمة"
        label-for="service-type-select"
          >
        <b-form-select
          id="service-type-select"
          v-model="form.service_type_id"
          :options="serviceTypeOptions"
          required
          :state="!!form.service_type_id"
          :placeholder="$t('serviceDetails.form.select_service_type')"
        />
          </b-form-group>
        </b-col>
        <b-col md="6" v-for="locale in locales" :key="locale">
          <text-input
              v-model="form['name_'+locale]"
              :label="$t('serviceDetails.form.name_'+locale)"
              :placeholder="$t('form.text.placeholder')"
              name="package-ad"
              rules="required"
          />
        </b-col>
        <b-col md="6" v-for="locale in locales" :key="locale">
          <text-input
              v-model="form['shortcut_name_'+locale]"
              :label="$t('serviceDetails.form.shortcut_name_'+locale)"
              :placeholder="$t('form.text.placeholder')"
              name="package-ad"
              rules="required"
          />
        </b-col>
        <b-col md="6" v-for="locale in locales" :key="locale">
          <text-input
              v-model="form['service_name_singular_'+locale]"
              :label="$t('serviceDetails.form.service_name_singular_'+locale)"
              :placeholder="$t('form.text.placeholder')"
              name="package-ad"
              rules="required"
          />
        </b-col>
        <b-col md="6" v-for="locale in locales" :key="locale">
          <text-input
              v-model="form['service_name_plural_'+locale]"
              :label="$t('serviceDetails.form.service_name_plural_'+locale)"
              :placeholder="$t('form.text.placeholder')"
              name="package-ad"
              rules="required"
          />
        </b-col>
        <b-col md="6" v-for="locale in locales" :key="locale">
          <text-input
              v-model="form['products_name_singular_'+locale]"
              :label="$t('serviceDetails.form.products_name_singular_'+locale)"
              :placeholder="$t('form.text.placeholder')"
              name="package-ad"
              rules="required"
          />
        </b-col>
        <b-col md="6" v-for="locale in locales" :key="locale">
          <text-input
              v-model="form['products_name_plural_'+locale]"
              :label="$t('serviceDetails.form.products_name_plural_'+locale)"
              :placeholder="$t('form.text.placeholder')"
              name="package-ad"
              rules="required"
          />
        </b-col>
        <b-col md="6" v-for="locale in locales" :key="locale">
          <text-input
              v-model="form['description_'+locale]"
              :label="$t('serviceDetails.form.description_'+locale)"
              :placeholder="$t('form.text.placeholder')"
              name="package-ad"
              rules="required"
          />
        </b-col>

        <b-col md="12">

          <wameed-input-file-upload
              fileType="images"
              field-classes="w-100"
              rule="required"
              functionType="front"
              v-model="form.image.name"
              :label="$t('serviceDetails.form.image')"
              :input-placeholder="$t('form.image.placeholder')"
              :input-append-text="$t('form.image.browse')"
              @changed="uploadProfileImage"
          />
        </b-col>

      </b-row>

      <template slot="modal-footer">
        <wameed-btn
            classes="  text-med-14 text-white mx-0 rounded-8"
            :title="modalData!=null ?$t('btn.update'):$t('btn.add')"
            :disabled="invalid"
            type="submit"
            variant="main"
            @onClick="submitOrder()"
        />
        <wameed-btn
            classes="  text-med-14 text-font-secondary mx-0 rounded-8 "
            :title="$t('btn.cancel')"
            type="button"
            variant="gray"
            @onClick="closeModal()"
        />
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import {WameedBtn, WameedTextInput as TextInput} from 'wameed-ui/dist/wameed-ui.esm';
import {mapActions} from 'vuex';
import {availableLocales} from '@/enums/locales.enum'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    WameedBtn,
    TextInput,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    modalData: {
      type: Object,
      default: null,
    },

  },

  data() {
   
    return {
      locales: availableLocales,
      form: {
        image: '',
          service_type_id: null,
      },
      
        serviceTypeOptions: [
      { value: 1, text: ' طلب من مطعم او متجر' },
      { value: 2, text: 'طلب توصيل' },
    ],
      showSuccessModal: false,
    };
    
  },
  computed: {

    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
  watch: {
    modalData(newVal) {
      if (newVal != null) {
        this.form = newVal;
      } else {
        this.form.name = '';
      }
    },
  },
  created() {
    
    if (this.modalData != null) {
      console.log('modalData', this.modalData);
      this.form = this.modalData
    }
  },
  methods: {
    ...mapActions({
      create: "admin/settings/services_detail/create",
      update: "admin/settings/services_detail/update",
    }),
    uploadProfileImage(value) {
      this.form.image = value;
    },


    submitOrder() {

      if (this.modalData == null) {
       // console.log(this.form);
  //  console.log('service_type_id', this.form.service_type_id);
        this.create(this.form).then(() => {
          this.$emit('onComplete', true);
          this.closeModal();
          this.$store.commit('loadingFinish', null, {root: true});
        });
      } else {
        this.update({
          ...this.form,
          id: this.modalData.id,

        }).then(() => {
          this.$emit('onComplete', true);
          this.closeModal();
          this.$store.commit('loadingFinish', null, {root: true});
        });
      }
    },


    closeModal() {
      this.form = {
        image: '',
      };
      this.show = false;
    },
  },
};
</script>
